// a datetime string ending with Z is considered UTC
export const dateStringToUTC = (dateString?: string) => {
  if (!dateString) {
    return
  }

  return dateString.slice(-1) === 'Z' ? dateString : `${dateString}Z`
}
